/* unplugin-vue-components disabled */import { render } from "./collapsed-md-table.vue?vue&type=template&id=45cfe5c7&scoped=true"
import script from "./collapsed-md-table.vue?vue&type=script&lang=js"
export * from "./collapsed-md-table.vue?vue&type=script&lang=js"

import "./collapsed-md-table.vue?vue&type=style&index=0&id=45cfe5c7&lang=stylus"
import "./collapsed-md-table.vue?vue&type=style&index=1&id=45cfe5c7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cfe5c7"],['__file',"src/components/md-content-v2/collapsed-md-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45cfe5c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45cfe5c7', __exports__)) {
    api.reload('45cfe5c7', __exports__)
  }
  
  module.hot.accept("./collapsed-md-table.vue?vue&type=template&id=45cfe5c7&scoped=true", () => {
    api.rerender('45cfe5c7', render)
  })

}


export default __exports__